/**
 * WebView 브리지 메시지 파싱·검증·직렬화
 * 정의된 type만 허용 (WEB_MESSAGE_TYPES / NATIVE_MESSAGE_TYPES)
 */
import { WEB_MESSAGE_TYPES, NATIVE_MESSAGE_TYPES } from '@template/types';
const ALLOWED_TYPES = new Set([
    WEB_MESSAGE_TYPES.NAVIGATE_BACK,
    WEB_MESSAGE_TYPES.FILE_DOWNLOAD,
    WEB_MESSAGE_TYPES.FILE_UPLOAD,
    WEB_MESSAGE_TYPES.READY,
    WEB_MESSAGE_TYPES.SET_THEME,
    WEB_MESSAGE_TYPES.REFRESH_TOKEN,
    WEB_MESSAGE_TYPES.RAW,
]);
/**
 * JSON 문자열을 WebMessage로 파싱
 * 정의된 type이 아니면 RAW로 정규화
 */
export function parseMessage(rawData) {
    if (!rawData || typeof rawData !== 'string') {
        return null;
    }
    try {
        const parsed = JSON.parse(rawData);
        if (parsed &&
            typeof parsed === 'object' &&
            'type' in parsed &&
            typeof parsed.type === 'string') {
            const { type, payload } = parsed;
            const normalizedType = ALLOWED_TYPES.has(type) ? type : WEB_MESSAGE_TYPES.RAW;
            return { type: normalizedType, payload };
        }
        return {
            type: WEB_MESSAGE_TYPES.RAW,
            payload: rawData,
        };
    }
    catch {
        return {
            type: WEB_MESSAGE_TYPES.RAW,
            payload: rawData,
        };
    }
}
/**
 * postMessage용 JSON 문자열로 직렬화
 */
export function serializeMessage(message) {
    return JSON.stringify(message);
}
/**
 * Native → Web 메시지 파싱
 * @param rawData - postMessage로 수신한 JSON 문자열
 * @returns 파싱된 메시지 또는 null
 */
export function parseNativeMessage(rawData) {
    if (!rawData || typeof rawData !== 'string') {
        return null;
    }
    try {
        const parsed = JSON.parse(rawData);
        if (parsed &&
            typeof parsed === 'object' &&
            'type' in parsed &&
            typeof parsed.type === 'string') {
            const { type, payload } = parsed;
            return { type, payload };
        }
        return null;
    }
    catch {
        return null;
    }
}
/** INIT 메시지 타입 가드 */
export function isInitMessage(message) {
    return message?.type === NATIVE_MESSAGE_TYPES.INIT;
}
/**
 * 네이티브 WebView 환경인지 여부
 * React Native WebView 내부에서 실행 중일 때 true
 */
export function isNativeWebView() {
    return (typeof window !== 'undefined' &&
        Boolean(window
            .ReactNativeWebView?.postMessage));
}
//# sourceMappingURL=webViewMessage.js.map